import React, { Component } from 'react';
import { reduxForm } from 'redux-form';
import {FormattedHTMLMessage} from 'react-intl';
import withAuthControl from '../auth/Auth.js';
import TopScrolleable from './TopScrolleable.js';
import generateValidator from './Validations/generateValidator';
import Section from './Section.js';
import CustomSpinner from './CustomSpinner';
import AttributeOptions from './AttributeOptions.js';
import CustomAlert from '../components/CustomAlert.js';
import { WAButton } from '../components/Button.js';

class ServiceInfoForm extends Component {

    constructor(props) {
        super(props);
        this.state = { cities: null };
    }

    render() {
        const { handleSubmit, submitting, error } = this.props;

        const vehicle = [{id:0, name:'Auto'},{id:1, name:'Moto'},{id:2, name:'No'}]
        const car_insurance = [{id:0 , name:'Sí'}, {id:1 , name:'No'}]

        return (
            <Section className="intro_form">
                <div className="row">
                    <div className="pd-content-left col-md-5 col-lg-5 text-center">
                        <img alt="Logo" className="center-block intro_logo" src={require(`../assets/${process.env.PAGE}/img/logo-h-blanco.png`)}/>
                        <FormattedHTMLMessage id="app.step_service_info" description="Service info"/>
                        <WAButton phone={this.context.intl.formatMessage({
                                      id:"app.step_sms_whatsapp_number", defaultMessage: "542612554220"})}
                                  text={this.context.intl.formatMessage({
                                      id:"app.step_sms_whatsapp_text", defaultMessage: "Tengo+una+consulta"})}
                                  value={this.context.intl.formatMessage({
                                      id:"app.step_sms_whatsapp_label", defaultMessage: "261-2554-220"})}
                                  gaEvent="true" gaCategory="CallToAction" gaAction="WhatsApp Tapping"/>
                        <FormattedHTMLMessage id="app.whatsapp_timetable" description="Wp timetable"/>
                    </div>
                    <div className="pd-content-right col-sm-12 col-md-7 col-lg-7">
                        <form onSubmit={handleSubmit(this.props.saveServiceInfoForm)} className="pvc-form">
                            {this.props.isLoading && <CustomSpinner message='Estamos analizando tu solicitud. Por favor esperá...' /> }
                            {error && <CustomAlert bsStyle="danger" message={error}/>}
                            <div className="row">
                                <div className="col-sm-12 col-md-6 col-lg-6">
                                    <div className="form-group">
                                        <AttributeOptions name="vehicle" defaultValue="Vehículo" label="Vehículo" attributeName='vehicle' attributeOptions={vehicle}/>
                                    </div>
                                </div>
                                <div className="col-sm-12 col-md-6 col-lg-6">
                                    <div className="form-group">
                                        <AttributeOptions name="car_insurance" defaultValue="Seguro Automotor" label="Seguro Automotor" attributeName='car_insurance' attributeOptions={car_insurance}/>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-12 col-md-12 col-lg-12 text-center">
                                    <button type="submit" className="btn btn-warning btn-lg pd-button pd-form" disabled={submitting}>Seguir</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </Section>
        );
    }
}

ServiceInfoForm.contextTypes = {
    intl: React.PropTypes.object.isRequired
}

let validate = generateValidator([{name: 'vehicle', required: true},
                                  {name: 'car_insurance', required: true}])

ServiceInfoForm = TopScrolleable(ServiceInfoForm);

ServiceInfoForm = reduxForm({
    form: 'JobInfoForm', // a unique name for this form
    validate
})(ServiceInfoForm);

ServiceInfoForm = withAuthControl(ServiceInfoForm);

export default ServiceInfoForm;


/** WEBPACK FOOTER **
 ** ./src/components/ServiceInfoForm.js
 **/